import * as React from "react";
import { IntlIcon } from "@/components/IntlIcon";
import { cn } from "@/lib/utils";

export interface SearchInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
  value: string;
  onValueChange: (value: string) => void;
  onClear?: () => void;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onValueChange, onClear, className, placeholder = "Search...", onFocus, onBlur, ...props }, ref) => {
    const [focused, setFocused] = React.useState(false);

    return (
      <div
        className={cn(
          "flex h-9 w-full items-center gap-2 bg-transparent px-3 transition-[border-color,border-width,border-radius]",
          focused
            ? "rounded-lg border-2 border-[var(--intl-accent)]"
            : "rounded-md border border-border",
          className
        )}
      >
        <input
          ref={ref}
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(event) => onValueChange(event.target.value)}
          onFocus={(event) => {
            setFocused(true);
            onFocus?.(event);
          }}
          onBlur={(event) => {
            setFocused(false);
            onBlur?.(event);
          }}
          className="intl-text-body-small flex-1 bg-transparent text-foreground outline-none placeholder:text-muted-foreground"
          {...props}
        />
        {value ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => {
              onValueChange("");
              onClear?.();
            }}
            className="shrink-0 rounded-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            <IntlIcon name="cross" className="h-6 w-6" />
          </button>
        ) : null}
      </div>
    );
  }
);
SearchInput.displayName = "SearchInput";

export { SearchInput };
